module.exports = __webpack_public_path__ + "img/FAQs.61352e68.png";